
export const SCHEDULE_STRINGS = {
    SCHEDULES: "Schedules",
    SEARCH_PAGE: "Search Page",
    SEARCH_SCHEDULES: "Search Schedules",
    SEARCH_MESSAGES: "Search Messages",
    SAVE_SCHEDULES: "Save Schedule",
    MODULE: "Module",
    PAGE: "Page",
    CONFIRM: "Confirm",
    CANCEL: "Cancel",
    DELETE: "Delete",
    CALIBRATE: "Calibrate",
    CALIBRATE_CONFIRMATION_TITLE: "Calibrate Schedules",
    INITIAL_OUTBOUND_MESSAGE: "Initial outbound message",
    DESCRIPTION: "Description",
    RECURRING: "Recurring",
    // Additional UI labels
    TITLE: "Title",
    START_DATE: "Start Date",
    END_DATE: "End Date",
    PAST_DUE_DAYS: "Past Due Days",
    CHANNEL: "Channel",
    EXTENSION_ELIGIBILITY: "Extension Eligibility",
    USE_AI: "Use AI",
    PERCENTAGES_SPLIT: "Percentages Split by day",
    TIMES_BY_DAY: "Times by day",
    INSERT_DATA_VARIABLES: "Insert data variables",
    TOTAL: "Total",
    UNNAMED_SCHEDULE: "Unnamed Schedule",
    ADD_LIBRARY: "Library",
    STOP_ALL_SCHEDULES: "Stop All Schedules",
    RESET_ALL_SCHEDULES: "Reset All Schedules",
    STOP_ALL_SCHEDULES_CONFIRMATION_TITLE: "Stop All Schedules Confirmation",
};

export const SCHEDULE_KEYS = {
    SCHEDULED_AT: "scheduled_at"
}

export const SCHEDULE_TABLE_COLUMNS = [
    { id: "actions", isSortable: false, label: "Actions" },
    { id: "scheduled_at", isSortable: true, label: "Date" },
    { id: "campaignname", isSortable: true, label: "Campaign" },
    { id: "messageCount", isSortable: true, label: "Message Count" },
    { id: "CampaignScheduleName", isSortable: true, label: "Schedule" },
    { id: "channeltypename", isSortable: true, label: "Channel" },
];

export const SCHEDULE_TABLE_COLUMN_KEYS = {
    ACTIONS: "actions",
    SCHEDULED_AT: "scheduled_at",
    CAMPAIGN_NAME: "campaignname",
    MESSAGE_COUNT: "messageCount",
    SCHEDULE_NAME: "CampaignScheduleName",
    CHANNEL: "channeltypename"
};

export const SCHEDULE_MESSAGES = {
    NO_SCHEDULES: "No schedules to display",
    NO_PAGES: "No pages found for this schedule.",
    CALIBRATE_CONFIRMATION: "This will disable all future scheduled messages and create new messages based on the active schedules. Are you sure you want to calibrate?",
    CALIBRATE_SUCCESS: "Schedules calibration job created successfully.",
    CALIBRATE_FAILURE: "Failed to create calibrate schedules job.",
    STOP_ALL_SCHEDULES_CONFIRMATION: "Are you sure you want to stop all schedules? This will halt all upcoming scheduled messages.",
    STOP_ALL_SCHEDULES_SUCCESS: "Stop All Schedules job queued successfully.",
    STOP_ALL_SCHEDULES_FAILURE: "Failed to queue Stop All Schedules job.",
};

export const SCHEDULE_ERRORS = {
    FETCH_SCHEDULES_ERROR: "Error fetching schedules.",
    FETCH_SCHEDULE_MESSAGES_ERROR: "Error fetching schedule messages.",
    UPDATE_SCHEDULE_MESSAGE_ERROR: "Failed to update schedule message.",
    UPDATE_ALL_SCHEDULE_DATA_ERROR: "Failed to update all schedule data.",
    STOP_ALL_SCHEDULES_ERROR: "Error queueing Stop All Schedules job:",
};

export const formatDatetoLocal = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleString("en-US", {
    month: "short",   // Feb
    day: "2-digit",   // 08
    year: "numeric",  // 2026
    hour: "2-digit",  // 02
    minute: "2-digit",// 00
    hour12: true      // PM format
  });
};

export const formatDateTime = (value) => {
    if (!value) return "";
    const normalized = value.replace("T", " ").replace("Z", "");
    const [datePart, timePart = "00:00:00"] = normalized.split(" ");
    const [year, month, day] = datePart.split("-");
    const [hour = "00", minute = "00"] = timePart.split(":");
    const h24 = Number(hour);
    const h12 = h24 % 12 || 12;
    const amPm = h24 >= 12 ? "PM" : "AM";
    const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];
    return `${monthNames[Number(month) - 1]} ${day}, ${year}, ${String(
        h12
    ).padStart(2, "0")}:${minute} ${amPm}`;
};